(function () {
  'use strict';
  function track(name) {
    document.dispatchEvent(
      new CustomEvent('myuser:tool-event', { detail: { name: name } })
    );
  }
  // Only the saved cart template gets this hook. Same-origin access lets the
  // parent read its size; iframe scripts and all other sandbox privileges stay
  // blocked. User-supplied HTML is never passed through this preview.
  document.querySelectorAll('iframe[data-guide-template-frame="cart"][srcdoc]').forEach(function (frame) {
    if (frame.getAttribute('sandbox') !== 'allow-same-origin') return;
    var observer;
    var queued = false;
    var lastHeight = 0;
    var currentDocument;
    function measure() {
      queued = false;
      if (!frame.isConnected || !currentDocument?.body) return;
      // This saved email is one table in a margin-free body. Its body box gives
      // the content height even when the iframe was taller at a narrower width.
      // documentElement.scrollHeight would include that old viewport height.
      var height = Math.ceil(currentDocument.body.getBoundingClientRect().height);
      if (height < 1 || height === lastHeight) return;
      lastHeight = height;
      frame.style.setProperty('--guide-template-height', height + 'px');
      frame.style.height = height + 'px';
    }
    function queueMeasure() {
      if (queued) return;
      queued = true;
      if (window.requestAnimationFrame) window.requestAnimationFrame(measure);
      else measure();
    }
    function connect() {
      var doc;
      try { doc = frame.contentDocument; } catch (_) { return; }
      if (!doc?.body || doc === currentDocument) return;
      currentDocument = doc;
      if (observer) observer.disconnect();
      if (window.ResizeObserver) {
        observer = new ResizeObserver(queueMeasure);
        observer.observe(doc.body);
        observer.observe(frame.parentElement);
      }
      doc.querySelectorAll('img').forEach(function (image) {
        image.addEventListener('load', queueMeasure, { once: true });
        image.addEventListener('error', queueMeasure, { once: true });
      });
      queueMeasure();
    }
    frame.addEventListener('load', connect);
    window.addEventListener('resize', queueMeasure);
    connect();
  });
  var controls = document.querySelector('[data-guide-controls]');
  if (controls) {
    controls.hidden = false;
    var active = 'all';
    var search = document.querySelector('[data-guide-search]');
    var cards = Array.from(document.querySelectorAll('[data-guide-card]'));
    var filters = Array.from(document.querySelectorAll('[data-guide-filter]'));
    var groups = Array.from(document.querySelectorAll('[data-guide-group]'));
    var topicGroups = Array.from(document.querySelectorAll('[data-guide-topic-group]'));
    var count = document.querySelector('[data-guide-count]');
    var empty = document.querySelector('[data-guide-empty]');
    var emptyQuery = document.querySelector('[data-guide-empty-query]');
    var clear = document.querySelector('[data-guide-clear]');
    var listHeading = document.querySelector('[data-guide-list-heading]');
    var directory = document.querySelector('.gh-index');
    var featuredHeading = document.querySelector('[data-guide-featured-heading]');
    var validTopics = filters.map(function (button) {
      return button.dataset.guideFilter;
    });
    function readGuideState() {
      var params = new URL(window.location.href).searchParams;
      var topic = params.get('topic');
      active = validTopics.includes(topic) ? topic : 'all';
      search.value = params.get('q') || '';
    }
    function writeGuideState() {
      var url = new URL(window.location.href);
      var query = search.value.trim();
      if (active === 'all') url.searchParams.delete('topic');
      else url.searchParams.set('topic', active);
      if (query) url.searchParams.set('q', query);
      else url.searchParams.delete('q');
      if (url.href !== window.location.href) {
        window.history.replaceState(window.history.state, '', url.href);
      }
    }
    function filterGuides(updateURL) {
      var query = search.value.trim().toLowerCase();
      var filtered = active !== 'all' || Boolean(query);
      if (directory) {
        directory.dataset.guideFiltered = String(filtered);
        directory.dataset.guideActiveTopic = active;
      }
      if (featuredHeading) featuredHeading.textContent = filtered ? 'Templates & checklists' : 'Emails you can use';
      var words = query.split(/\s+/).filter(Boolean);
      var visible = 0;
      cards.forEach(function (card) {
        var text = (card.dataset.guideSearchable || '').toLowerCase();
        var show =
          (active === 'all' || card.dataset.guideTopic === active) &&
          words.every(function (word) {
            return text.includes(word);
          });
        card.hidden = !show;
        if (show) visible++;
      });
      filters.forEach(function (b) {
        b.setAttribute(
          'aria-pressed',
          String(b.dataset.guideFilter === active)
        );
      });
      groups.forEach(function (group) {
        group.hidden = !Array.from(group.querySelectorAll('[data-guide-card]'))
          .some(function (card) { return !card.hidden; });
      });
      topicGroups.forEach(function (group) {
        group.hidden = !Array.from(group.querySelectorAll('[data-guide-card]'))
          .some(function (card) { return !card.hidden; });
      });
      var selectedFilter = filters.find(function (button) {
        return button.dataset.guideFilter === active;
      });
      // Use the topic label for the results heading and empty-state message.
      var topicLabel = selectedFilter ? Array.from(selectedFilter.childNodes)
        .filter(function (node) { return node.nodeType === 3; })
        .map(function (node) { return node.textContent; }).join('').trim() : 'All guides';
      if (listHeading) listHeading.textContent = query ? 'Search results' : active === 'all' ? 'All guides' : topicLabel;
      count.textContent = visible + (visible === 1 ? ' guide' : ' guides');
      empty.hidden = visible !== 0;
      if (emptyQuery) emptyQuery.textContent = active !== 'all'
        ? 'No matches in “' + topicLabel + '”. Try another word, or clear the filters.'
        : 'Try another word, or clear your search.';
      if (clear) clear.hidden = active === 'all' && !query;
      if (updateURL) writeGuideState();
    }
    filters.forEach(function (b) {
      b.addEventListener('click', function () {
        active = b.dataset.guideFilter;
        filterGuides(true);
      });
    });
    search.addEventListener('input', function () { filterGuides(true); });
    // The results update as you type, so on a phone the keyboard's Search
    // key only needs to put the keyboard away and show them.
    var canHover = function () { return !window.matchMedia || window.matchMedia('(hover: hover)').matches; };
    search.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && !canHover()) search.blur();
    });
    document.querySelectorAll('[data-guide-reset]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        active = 'all';
        search.value = '';
        filterGuides(true);
        // The button hides itself, so focus has to move. Keyboards and mice
        // go back to the search box as before; a tap on a touch screen lands
        // on "All guides" instead, so the phone doesn't open its keyboard.
        if (event.detail === 0 || canHover()) search.focus();
        else filters[0].focus({ preventScroll: true });
      });
    });
    window.addEventListener('popstate', function () {
      readGuideState();
      filterGuides(false);
    });
    // The page shows these controls before this script arrives (an inline
    // script in growth-hub.cjs, so the guide list never jumps down under the
    // reader). Keep anything typed into the box in the meantime.
    var typedEarly = search.value;
    readGuideState();
    if (typedEarly && !search.value) search.value = typedEarly;
    filterGuides(Boolean(typedEarly));
  }
  document.querySelectorAll('[data-copy-example]').forEach(function (button) {
    button.hidden = false;
    button.addEventListener('click', async function () {
      var example = button.closest('[data-example]');
      var status = example.querySelector('[data-example-status]');
      try {
        await navigator.clipboard.writeText(
          example.querySelector('[data-example-code]')?.textContent ||
            example.querySelector('[data-example-copy]').innerText
        );
        track('guide_example_copied');
        button.textContent =
          button.dataset.copyKind === 'scenario'
            ? 'Scenario copied ✓'
            : 'Copied ✓';
        status.textContent =
          button.dataset.copyKind === 'scenario'
            ? 'Example copied. Keep it in your notes to help decide what to do.'
            : 'Copied to your clipboard. Check the details before using it.';
      } catch (_) {
        status.textContent =
          'Clipboard unavailable. Select the example text and copy it manually.';
      }
    });
  });
})();
